<template>
  <div class="space-y-2 py-4">
    <div v-if="primary" class="text-gray-500 text-sm font-medium">Primary</div>
    <div class="flex space-x-2 items-start">
      <div class="w-64">
        <EmailAddressForm
          :save-action="updateEmailAddress"
          :email-address="emailAddress"
          :disabled="loading"
        />
      </div>
      <div class="flex none">
        <BaseButton ghost :disabled="loading" @click="deleteEmailAddress"> Delete </BaseButton>
      </div>
      <div v-if="!primary" class="flex none">
        <BaseButton ghost :disabled="loading" @click="makeEmailAddressPrimary">
          Make primary
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { contactEmailAddressesClient, contactPrimaryEmailAddressesClient } from '@/api/clients';
import EmailAddressForm from './EmailAddressForm.vue';

export default {
  components: {
    EmailAddressForm,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
    emailAddress: {
      type: Object,
      required: true,
    },
    primary: Boolean,
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async updateEmailAddress(formData) {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactEmailAddressesClient.update(this.contactId, this.emailAddress.id, formData);

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    async makeEmailAddressPrimary() {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactPrimaryEmailAddressesClient.store(this.contactId, {
          address: this.emailAddress.address,
        });

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteEmailAddress() {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactEmailAddressesClient.destroy(this.contactId, this.emailAddress.id);

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
